module.exports = __webpack_public_path__ + "assets/3069d1534e35248917a987e195172c3d.mp4";